<template>
	<validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
		<slot name="header">
			<h4 class="mb-4">Report</h4>
		</slot>

		<b-form @submit.prevent="submitForm">
			<base-input
				v-model="models.display_name"
				rules="required"
				name="Name"
				label="Name"
			></base-input>

			<div class="mt-4 d-flex justify-content-between">
				<slot name="return"></slot>
				<slot name="submit">
					<base-button
						:disabled="invalid"
						:loading="formProcessing"
						type="primary"
						native-type="submit"
						size="md"
						class="form-btn font-weight-normal"
					>
						<slot name="submit-text">Save</slot>
					</base-button>
				</slot>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
export default {
	name: "report-name-form",
	inject: ["reportSvc", "ErrorService"],
	data() {
		return {
			formProcessing: false,
			models: {},
		};
	},
	watch: {
		"reportSvc.report": {
			deep: true,
			immediate: true,
			handler: function (val) {
				this.models = {
					id: val.id,
					display_name: val.display_name,
				};
			},
		},
		formProcessing: function (val) {
			this.$bus.$emit("report-name-form-processing", val);
		},
	},
	methods: {
		async submitForm() {
			this.formProcessing = true;

			const response = await this.reportSvc.update(this.models);

			if (200 === response.data.status)
				this.$bus.$emit(
					"report-name-form-success",
					response.data.data.data
				);

			this.$toasted.show(response.data.data.message);

			this.reset();
		},
		reset() {
			this.$refs.form.reset();

			Object.assign(this.$data, this.$options.data.apply(this));
		},
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);
	},
	beforeDestroy() {
		this.reportSvc.set("report", null);

		this.reset();
	},
};
</script>
